export class OrganizationClient {
  constructor({ url, _get }) {
    this.url = url
    this.get = _get
  }

  help() {
    console.log('getById(id)')
  }

  async getById(id) {
    if(!id) {
      return { status: '', plan: '', name: '', logo: '' }
    }

    const url = `${this.url}/api/organization/get/${id}`
    const res = await this.get(url, {result: {}})

    return res.result
  }
}
